
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Form, Button, Spinner as Loading } from "react-bootstrap";
import "../animation.css";

const MailchimpForm = ({ show, onHide, status, message, onValidated }) => {
	const [error, setError] = useState(null);
	const [email, setEmail] = useState("");
	const [firstName, setFirstName] = useState("");
	/*const [lastName, setLastName] = useState("");
	const [postalCode, setPostalCode] = useState("");
	const [city, setCity] = useState("");*/
	const [privacy, setPrivacy] = useState(false);
	const [closing, setClosing] = useState(false);

	const handleClose = () => {
		setClosing(true);
		setTimeout(() => {
			setClosing(false);
			onHide();
		}, 600);
	};

	const handleFormSubmit = () => {
		const isFormValidated = onValidated({
			EMAIL: email,
			VORNAME: firstName,
			// NACHNAME: lastName,
			// PLZ: postalCode,
			// ORT: city,
		});
		return email && email.indexOf("@") > -1 && isFormValidated;
	};

	const handleInputKeyEvent = (event) => {
		setError(null);
		if (event.keyCode === 13) {
			event.preventDefault();
			handleFormSubmit();
		}
	};

	const privacyLabel = () => (
		<div>
			Ja, ich habe die{" "}
			<Link
				style={{ color: "#d4b66b", textDecoration: "underline" }}
				to="/privacy"
			>
				Datenschutzerklärung
			</Link>{" "}
			zur Kenntnis genommen. *
		</div>
	);

	return (
		<Modal
			show={show}
			onHide={handleClose}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName={closing ? "modal-slide-out" : ""}
			backdrop={closing ? false : true}
			animation={false}
		>
			<Modal.Header closeButton>
				{status === "error" || status === "success" ? (
					<Modal.Title id="contained-modal-title-vcenter">
						{"error" === status || error ? (
							<div>Hoppla, probiere es bitte nocheinmal</div>
						) : null}
						{"success" === status && "error" !== status && !error && (
							<div>Newsletter Anmeldung erfolgreich</div>
						)}
					</Modal.Title>
				) : (
					<Modal.Title id="contained-modal-title-vcenter">
						Anmeldung zu meinem Newsletter "LICHTBLICK"
					</Modal.Title>
				)}
			</Modal.Header>

			{status === "error" || status === "success" ? (
				<Modal.Body>
					<div className="min-h-42px">
						{"sending" === status ? <Loading /> : null}
						{"error" === status || error ? (
							<>
								<br />
								<div
									className="swal2-icon swal2-error swal2-animate-error-icon"
									style={{ display: "flex" }}
								>
									<div className="swal2-error-circular-line-left"></div>
									<span className="swal2-error-line-tip"></span>
									<span className="swal2-error-line-long"></span>
									<div className="swal2-error-ring"></div>
									<div className="swal2-x-mark-line-left"></div>
									<div className="swal2-x-mark-line-right"></div>
								</div>
								<br />
								<div>
									Das hat leider nicht geklappt. Vergewissere Dich bitte, ob Du
									die beiden Pflichtfelder „Email“ und „Vorname“ ausgefüllt und
									eine aktive Mailadresse angegeben hast. Danke.
								</div>
							</>
						) : null}

						{"success" === status && "error" !== status && !error && (
							<>
								<br />
								<div
									className="swal2-icon swal2-success swal2-animate-success-icon"
									style={{ display: "flex" }}
								>
									<div className="swal2-success-circular-line-left"></div>
									<span className="swal2-success-line-tip"></span>
									<span className="swal2-success-line-long"></span>
									<div className="swal2-success-ring"></div>
									<div className="swal2-success-fix"></div>
									<div className="swal2-success-circular-line-right"></div>
								</div>
								<br />
								<div>
									Deine Anmeldung zum „LICHTBLICK“ war erfolgreich. Schön, dass
									Du dabei bist.
								</div>
							</>
						)}
					</div>
				</Modal.Body>
			) : (
				<Modal.Body>
					<Form.Group>
						<Form.Control
							onChange={(e) => setEmail(e.target.value ?? "")}
							type="email"
							placeholder="E-Mail-Adresse*"
							onKeyUp={handleInputKeyEvent}
							style={{ marginBottom: "1rem" }}
						/>
						<Form.Control
							onChange={(e) => setFirstName(e.target.value ?? "")}
							type="text"
							placeholder="Vorname*"
							onKeyUp={handleInputKeyEvent}
							style={{ marginBottom: "1rem" }}
						/>

						{/* 
						<Form.Control
							onChange={(e) => setLastName(e.target.value ?? "")}
							type="text"
							placeholder="Nachname"
							onKeyUp={handleInputKeyEvent}
							style={{ marginBottom: "1rem" }}
						/>
						<Form.Control
							onChange={(e) => setPostalCode(e.target.value ?? "")}
							type="number"
							placeholder="Postleitzahl"
							onKeyUp={handleInputKeyEvent}
							style={{ marginBottom: "1rem" }}
						/>
						<Form.Control
							onChange={(e) => setCity(e.target.value ?? "")}
							type="text"
							placeholder="Ort"
							onKeyUp={handleInputKeyEvent}
							style={{ marginBottom: "1rem" }}
						/>*/}
						{/*<p>
							Gut zu wissen: Wenn Du an Heilkreisen und Zeremonien in Deiner
							Region interessiert bist, kannst Du freiwillig Deine PLZ und Deinen
							Wohnort mitangeben.
						</p>*/}
						

						<Form.Check
							style={{
								fontSize: "14px",
								fontFamily: "Lato",
								marginBottom: "12px",
							}}
							required
							type="checkbox"
							label={privacyLabel()}
							onChange={() => setPrivacy(!privacy)}
						/>

						<Button
							disabled={!email || !privacy || !firstName}
							onClick={handleFormSubmit}
						>
							ANMELDEN
						</Button>
						<br />
						<Form.Label
							style={{
								fontSize: "12px",
								fontFamily: "Lato",
							}}
						>
							* Pflichtfelder
						</Form.Label>
					</Form.Group>
				</Modal.Body>
			)}

			<Modal.Footer>
				<Button className="btn-secondary" onClick={handleClose}>Schließen</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default MailchimpForm;
